module.exports = __webpack_public_path__ + "img/kuntong2.3dad0455.png";